/* Med Logos: indicador de rolagem ancorado aos mockups de dispositivo de /pages/web-design (hero e demais: .pg-svc-device e .pg-svc-device__phone--big).
   Cada mockup ganha uma linha (o hero some após 40 px de rolagem; os demais só ficam visíveis enquanto o mockup está na viewport, via IntersectionObserver).
   Posição pelo bounding rect do mockup: 16 px à esquerda, centrado na altura; à direita se a esquerda chegar a menos de 24 px de texto; some se nenhum lado couber.
   O elemento vai para o body (o container da página corta o overflow horizontal). Sem biblioteca; erro nunca quebra a página. */
(function () {
  try {
    var tpl = document.querySelector('[data-pgcue]'); if (!tpl) return;
    var W = 2, GAP = 16, RESPIRO = 24, items = [];
    function sy() { return window.scrollY || document.documentElement.scrollTop; }
    function textRects(dev) {
      var out = [], scope = dev.closest('section') || document.body;
      scope.querySelectorAll('h1,h2,h3,p,li,a,button').forEach(function (el) {
        if (dev.contains(el) || el.closest('[aria-hidden="true"]')) return;
        if (el.matches('a,button')) { out.push(el.getBoundingClientRect()); return; }
        var r = document.createRange(); r.selectNodeContents(el);
        Array.prototype.forEach.call(r.getClientRects(), function (q) { if (q.width > 1) out.push(q); });
      });
      return out;
    }
    function hits(x, y0, y1, rects) {
      for (var i = 0; i < rects.length; i++) { var q = rects[i];
        if (x + W + RESPIRO > q.left && x - RESPIRO < q.right && y1 > q.top && y0 < q.bottom) return true; }
      return false;
    }
    function place(it) {
      var dev = it.dev, c = it.c, r = dev.getBoundingClientRect();
      if (!r.width) { c.classList.add('is-nofit'); return; }
      var ph = dev.matches('.pg-svc-device') ? dev.querySelector('.pg-svc-device__phone') : null, pr = ph ? ph.getBoundingClientRect() : r;
      var right = Math.max(r.right, pr.right), h2 = c.offsetHeight, yc = r.top + r.height / 2, y0 = yc - h2 / 2, y1 = yc + h2 / 2;
      var tr = textRects(dev), vw = document.documentElement.clientWidth;
      var xl = Math.max(6, r.left - GAP - W), xr = right + GAP, x = null;
      if (!hits(xl, y0, y1, tr)) x = xl; else if (xr + W <= vw - 6 && !hits(xr, y0, y1, tr)) x = xr;
      if (x === null) { c.classList.add('is-nofit'); return; }
      c.classList.remove('is-nofit');
      c.style.left = Math.round(x) + 'px'; c.style.top = Math.round(y0 + sy()) + 'px';
    }
    function placeAll() { items.forEach(place); }
    var devs = Array.prototype.slice.call(document.querySelectorAll('.pg-svc-device, .pg-svc-device__phone--big'));
    devs.forEach(function (dev, i) {
      var c = i === 0 ? tpl : tpl.cloneNode(true); document.body.appendChild(c);
      var it = { dev: dev, c: c, hero: !!dev.closest('.pg-svc-hero--web') }; items.push(it);
      if (!it.hero) c.classList.add('is-out');
    });
    var on = false;
    function sync() { var g = sy() > 40; if (g !== on) { on = g; items.forEach(function (it) { if (it.hero) it.c.classList.toggle('is-gone', g); }); } }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) {
        items.forEach(function (it) { if (it.dev === e.target && !it.hero) it.c.classList.toggle('is-out', !e.isIntersecting); }); }); }, { threshold: 0.15 });
      items.forEach(function (it) { if (!it.hero) io.observe(it.dev); });
    } else items.forEach(function (it) { it.c.classList.remove('is-out'); });
    placeAll(); sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', placeAll);
    window.addEventListener('load', placeAll);
    setTimeout(placeAll, 1500);
    if (window.ResizeObserver) { var ro = new ResizeObserver(placeAll); items.forEach(function (it) { ro.observe(it.dev); var s = it.dev.closest('section'); if (s) ro.observe(s); }); }
  } catch (e) {}
})();
